import { render, staticRenderFns } from "./BFieldBlock.vue?vue&type=template&id=5050018b&"
import script from "./BFieldBlock.vue?vue&type=script&lang=js&"
export * from "./BFieldBlock.vue?vue&type=script&lang=js&"
import style0 from "./BFieldBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports